// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyState_wrapper__PEBNF","icon":"EmptyState_icon__-aF4d","title":"EmptyState_title__204U3","message":"EmptyState_message__8hat7"};